import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();

  return (
    <nav aria-label="Breadcrumb" className="w-full px-4 md:px-6 py-4">
      <ol className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">
            {t("breadcrumb_home")}
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-500 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}